import React from 'react';
import { useTranslation } from 'react-i18next';
import { TransactionType } from './AddTransactionFlow';
import { Icon } from '../Icon';
import './TransactionTypeSelector.css';

interface TransactionTypeSelectorProps {
  value?: TransactionType;
  onChange: (type: TransactionType) => void;
}

export const TransactionTypeSelector: React.FC<TransactionTypeSelectorProps> = ({ value, onChange }) => {
  const { t } = useTranslation();
  return (
    <div className="transaction-type-selector step-content">
      <div className="transaction-type-selector__header">
        <h2 className="transaction-type-selector__title">{t('transaction.flow.whatToAdd')}</h2>
        <p className="transaction-type-selector__subtitle">{t('transaction.flow.selectType')}</p>
      </div>

      <div className="transaction-type-selector__options">
        <button
          className={`type-option ${value === 'expense' ? 'type-option--active' : ''}`}
          onClick={() => onChange('expense')}
        >
          <div className="type-option__icon type-option__icon--expense">
            <Icon name="trending-down" size={32} color="#FF3B30" />
          </div>
          <div className="type-option__content">
            <div className="type-option__title">{t('transaction.expense')}</div>
            <div className="type-option__description">{t('transaction.flow.expenseDesc')}</div>
          </div>
          <div className="type-option__check">
            {value === 'expense' && <Icon name="check" size={16} color="white" />}
          </div>
        </button>

        <button
          className={`type-option ${value === 'income' ? 'type-option--active' : ''}`}
          onClick={() => onChange('income')}
        >
          <div className="type-option__icon type-option__icon--income">
            <Icon name="trending-up" size={32} color="#34C759" />
          </div>
          <div className="type-option__content">
            <div className="type-option__title">{t('transaction.income')}</div>
            <div className="type-option__description">{t('transaction.flow.incomeDesc')}</div>
          </div>
          <div className="type-option__check">
            {value === 'income' && <Icon name="check" size={16} color="white" />}
          </div>
        </button>
      </div>
    </div>
  );
};

